module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAJFBMVEUAAAAAc8gAc8gAcskAc8gAc8kAc8gAc8kAc8gAcskAcsoAc8imTQWQAAAAC3RSTlMA8nsV5rCkcF4wAgBE1esAAAApSURBVAjXY/BWYGAwY5BWYODcDSKrNwLJpbuBZPNuKAkVgchCVEJ0AQDayRAx7B+g7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_bgPrevious.png
// module id = 38US
// module chunks = 9